export const daysDiff = (endDate, startDate) => {
    return Math.round(Math.abs((endDate - startDate) / (1000 * 60 * 60 * 24))) + 1;
};

export const getDateRangeLabel = (startDate, endDate, label, translate) => {
    const days = daysDiff(new Date(endDate), new Date(startDate));
    if (!days) {
        return label;
    }

    const daysWord = days === 1 ? translate('analytics.common.day') : translate('analytics.common.days');
    return `${label} - ${days} ${daysWord}`;
};

export const pluralizeDays = (count, translate) => {
    if (count === 1) return translate('analytics.common.day');
    return translate('analytics.common.days');
};
